module.exports = __webpack_public_path__ + "static/konex.a9043460.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Venue/konex.png
// module id = 631
// module chunks = 35783957827783